module.exports = __webpack_public_path__ + "static/media/ex17.0eb13b24.jpg";